<div *ngIf="control.visible" [formGroup]="pageFormGroup" [ngClass]="'control-'+(isDesigner ? 'edit' : 'preview')">
  
  <div *ngIf="isDesigner; else isNotDesigner" tabindex="0" class="content"
    (mousedown)="isDesigner ? onShowConfiguration($event, configurationType.Control, page, control) : null"
    (keydown)="isDesigner ? handleKey($event, configurationType.Control, page, control) : null"
    pDraggable  pDroppable 
    (onDragStart)="onControlDragStart($event, page, control)"
    (onDragEnd)="onControlDragEnd($event, page, control)"
    (onDrop)="onControlDrop($event, page, control)">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>

  <ng-template #isNotDesigner>

    <div class="content">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>

  </ng-template>

  <ng-template #content>
    <div class="flex flex-column w-full">
      <div class="flex justify-content-end icon-bar gap-1" *ngIf="isDesigner">
        @if (typeChecker.hasReadonly(control)) {
          <custom-tag *ngIf="control.readonly"
            [toolTip]="'common.readonly' | translate" iconClass="pi pi-book" backgroundColor="var(--silver)">
          </custom-tag>        
        }
        <custom-tag *ngIf="control.hasConditions()"
          [toolTip]="'dynamic-form.builder.hasEnableIf' | translate" iconClass="pi pi-bolt" backgroundColor="var(--denim)">
        </custom-tag> 
        <custom-tag *ngIf="control.isRequired"
          [toolTip]="'dynamic-form.builder.requerido' | translate" iconClass="pi pi-star" backgroundColor="var(--sandy-brown)">
        </custom-tag>
      </div>
      <div class="flex flex-column align-items-start gap-1">
        @if(!typeChecker.isLabel(control)) {
          <label [for]="control.name" class="control-label flex align-items-center gap-1"> 
            {{control.label}} 
            @if(control.isRequired){
              <span style="color: red">*</span>
            }
            @if(typeChecker.hasTooltip(control) && control.tooltip !== ''){
              <i class="pi pi-info-circle" [style.color]="'#3282F3'"
                [pTooltip]="control.tooltip" [escape]="false" tooltipPosition="top"></i>
            }
          </label>
        }
  
        <!-- Region: Controls -->
        @if (typeChecker.isInputText(control)) {
          <app-text-control [control]="control" [formGroup]="pageFormGroup"></app-text-control>
        } @else if (typeChecker.isInputNumber(control)) {
          <app-number-control [control]="control" [formGroup]="pageFormGroup"></app-number-control>
        } @else if (typeChecker.isDropdown(control)) {
          <app-dropdown-control [control]="control" [formGroup]="pageFormGroup"></app-dropdown-control>
        } @else if (typeChecker.isCalendar(control)) {
          <app-calendar-control [control]="control" [formGroup]="pageFormGroup"></app-calendar-control>
        } @else if (typeChecker.isCheckbox(control)) {
          <app-checkbox-control [control]="control" [formGroup]="pageFormGroup"></app-checkbox-control>
        } @else if (typeChecker.isFileUpload(control)) {
          <app-file-upload-control [control]="control" [formGroup]="pageFormGroup" [isDesigner]="isDesigner"></app-file-upload-control>
        } @else if (typeChecker.isInputMask(control)) {
          <form-input-mask-control [control]="control" [formGroup]="pageFormGroup"></form-input-mask-control>
        } @else if (typeChecker.isLabel(control)) {
          <form-label-control [control]="control"></form-label-control>
        } @else if (typeChecker.isTextArea(control)) {
          <app-textarea-control [control]="control" [formGroup]="pageFormGroup"></app-textarea-control>
        } @else if (typeChecker.isSubFormulario(control)) {
          <app-sub-formularios-container [control]="control"></app-sub-formularios-container>
        }
        <!-- End Region: Controls -->
  
        <ng-container
          *ngIf="getControlFormGroup(control.name).invalid && (getControlFormGroup(control.name).touched || page.submitted)">
          <small [id]="control.name + '-help'" class="p-error block">
            {{fc.getValidationError(getControlFormGroup(control.name)) }} </small>
        </ng-container>
        <div *ngIf="isDesigner" class="flex w-full">
          <button pButton type="button" [label]="'dynamic-form.builder.borrar-campo'| translate" (click)="fc.Form.deleteControlByName(control.name)"
            icon="pi pi-trash" class="p-button-sm w-full p-button-danger p-button-outlined"></button>
        </div>
      </div>
    </div>
  </ng-template>
</div>